<template>
  <div>
    <DarwinButton
      size="md"
      kind="primary"
      flair="rounded"
      :disabled="!isReady"
      @click="showRelevantDialog"
    >
      <template
        v-if="isStorageIntegrationAtLimit"
        #icon-append
      >
        <Icon name="duotone-star" />
      </template>
      <template
        v-else
        #icon-prepend
      >
        <Icon name="mono-plus" />
      </template>
      New Storage Integration
    </DarwinButton>

    <StorageModal v-model:open="isCreationDialogVisible" />

    <DarwinDialog
      :open="isUpgradeDialogVisible"
      fullscreen
      max-height="900"
      @keydown:esc="isUpgradeDialogVisible = false"
    >
      <UpgradeDialog @close="isUpgradeDialogVisible = false">
        <template #title> Upgrade your plan to add Storage Integrations </template>
      </UpgradeDialog>
    </DarwinDialog>
  </div>
</template>

<script lang="ts">
export default {
  name: 'StorageCreation',
}
</script>

<script lang="ts" setup>
import { ref } from 'vue'
import DarwinButton from '@/uiKit/Button/DarwinButton.vue'
import StorageModal from './StorageModal.vue'
import Icon from '@/uiKit/Icon/Icon.vue'

import DarwinDialog from '@/uiKit/Dialog/DarwinDialog.vue'
import UpgradeDialog from '@/modules/Billing/UpgradeDialog.vue'
import { useResourceStorageIntegration } from '@/modules/Billing/useResourceStorageIntegration'

const isCreationDialogVisible = ref(false)
const isUpgradeDialogVisible = ref(false)

const { isStorageIntegrationAtLimit, isReady } = useResourceStorageIntegration()

const showRelevantDialog = (): void => {
  isStorageIntegrationAtLimit.value
    ? (isUpgradeDialogVisible.value = true)
    : (isCreationDialogVisible.value = true)
}
</script>
